export enum ShiftEventCategory {
  Mechanical = 'mechanical',
  Electrical = 'electrical',
  Quality = 'quality',
  Process = 'process',
  Environment = 'environment',
  HealthAndSafety = 'healthAndSafety',
  Production = 'production',
  Cleaning = 'cleaning',
  Cost = 'cost',
  Other = 'other'
}

export enum StoppageKind {
  Incident = 'incident',
  Circumstance = 'circumstance',
  PlannedStoppage = 'plannedStoppage',
  Other = 'other'
}

export const shifthandoverStoppagesList: StoppageKind[] = [
  StoppageKind.Incident,
  StoppageKind.Circumstance,
  StoppageKind.PlannedStoppage
]

export const eventTypesInterchangeable = [
  'malfunction',
  'healthAndSafety',
  'task',
  'information',
  'idea',
  'environment',
  'parameterChange',
  'systemChangeRequest',
  'quality',
  'spot'
] as const
export type EventTypeInterchangeable = (typeof eventTypesInterchangeable)[number]

export const eventTypes = [...shifthandoverStoppagesList, ...eventTypesInterchangeable] as const
export type EventType = StoppageKind | EventTypeInterchangeable
